import type {ComponentType} from 'react';

export type ActionPayload = unknown;
export type ActionHandler = (payload?: ActionPayload) => void;

export type ComponentKey = ComponentType<any>;

class ActionBus {
    private subscribers: WeakMap<ComponentKey, Set<ActionHandler>> = new WeakMap();

    subscribe(componentType: ComponentKey, handler: ActionHandler): () => void {
        let set = this.subscribers.get(componentType);
        if (!set) {
            set = new Set<ActionHandler>();
            this.subscribers.set(componentType, set);
        }
        set.add(handler);
        return () => {
            set!.delete(handler);
            if (set!.size === 0) {
                this.subscribers.delete(componentType);
            }
        };
    }

    trigger(target: ComponentKey | ComponentKey[], payload?: ActionPayload): void {
        const targets = Array.isArray(target) ? target : [target];
        for (const t of targets) {
            const set = this.subscribers.get(t);
            if (!set || set.size === 0) continue;
            for (const handler of Array.from(set)) {
                try {
                    handler(payload);
                } catch (err) {
                    console.error(err);
                }
            }
        }
    }
}

export const actionBus = new ActionBus();


